// function that takes in seconds and formats it into a readable string
// format: xdays xhours, xminutes, xseconds
const ONE_DAY_IN_SECONDS = 60 * 60 * 24
const ONE_HOUR_IN_SECONDS = 60 * 60
const ONE_MINUTE_IN_SECONDS = 60

export function formatTime(seconds) {
    if(!Number.isInteger(seconds) || seconds < 0) {
        console.error("Not a valid input")
        return ''
    } 
    // Start at the upper bound, hours, then calculate it and substract its value in seconds from the total
    let total = seconds;

    const days = Math.floor(total / ONE_DAY_IN_SECONDS)
    total -= days * ONE_DAY_IN_SECONDS

    const hours = Math.floor(total / ONE_HOUR_IN_SECONDS)
    total -= hours * ONE_HOUR_IN_SECONDS

    const minutes = Math.floor(total / ONE_MINUTE_IN_SECONDS)
    total -= minutes * ONE_MINUTE_IN_SECONDS

    const s = total

    // build the results string based on whats avaliable
    const result = []

    if(days) result.push(`${days}d`)
    if(hours) result.push(`${hours}h`)
    if(minutes) result.push(`${minutes}m`)
    if(!days & !hours) result.push(`${s}s`)

    return result.length ? result.join(" ") : "N/A"
}